<div fxLayut="column" fxLayoutGap="10px">
	<h1 mat-dialog-title>Browse CSV</h1>
	<input type="file" accept=".csv" (change)="fileBrowseHandler($event.target.files)" />
	<div mat-dialog-actions>
		<button mat-button mat-dialog-close color="warn">
			Cancel
		</button>
		<button (click)="uploadDocument()" mat-button [disabled]="form.invalid" color="primary" [mat-dialog-close]="form">
			Save
		</button>
	</div>
</div>
